export function useScoreColor({ minScore = 0, goodScore = 450, maxScore = 1000 } = {}) {
    
    function getColor(value) {
        if (typeof value !== 'number' || isNaN(value)) return undefined
        const score = Number(value)

        let hue

        if (score <= minScore) {
            hue = 0 // red

        } else if (score <= goodScore) {
            // dark red → green
            const ratio = (score - minScore) / (goodScore - minScore)
            hue = 0 + ratio * 120 // 0 = red, 120 = green

        } else if (score <= maxScore) {
            // green → blue/purple
            const ratio = (score - goodScore) / (maxScore - goodScore)
            hue = 120 + ratio * 240 // 120 = green, 360 = purple
            if (hue > 360) hue -= 360

        } else {
            hue = 240 // cap at max hue (blue/purple)
        
        }

        return `hsl(${hue}, 80%, 45%)`
    }

    return { getColor }
}